import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { resolveAllowedDefaultTab, sectionGroupKey } from "@/lib/defaultTab";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { usePersonEducationCapability } from "../person/_usePersonEducationAccess";

export default function EducationIndex() {
  const { pgaId } = useParams();
  const location = useLocation();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const base = location.pathname.replace(/\/$/, "");
  const group = sectionGroupKey(location.pathname);
  const { loaded, canViewPersonEducation } = usePersonEducationCapability();
  const allowedTabs = [
    "professional-development",
    "learning",
    "program",
    flags["backoffice-education-credentials"] && "credentials",
    "certifications"
  ].filter((slug): slug is string => Boolean(slug));
  const tab =
    flags["backoffice-navigation-preferences"] === true
      ? resolveAllowedDefaultTab(group ?? "", allowedTabs, "professional-development")
      : "professional-development";

  if (!pgaId || !loaded || !flagsLoaded) return null;

  if (!canViewPersonEducation) {
    return <Navigate to={`/people/${pgaId}/person/overview`} replace />;
  }

  return <Navigate to={`${base}/${tab}`} replace />;
}
